"use strict";
//  Copyright 2018, Venkat Peri.
//
//  Permission is hereby granted, free of charge, to any person obtaining a
//  copy of this software and associated documentation files (the
//  "Software"), to deal in the Software without restriction, including
//  without limitation the rights to use, copy, modify, merge, publish,
//  distribute, sublicense, and/or sell copies of the Software, and to permit
//  persons to whom the Software is furnished to do so, subject to the
//  following conditions:
//
//  The above copyright notice and this permission notice shall be included
//  in all copies or substantial portions of the Software.
//
//  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
//  OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
//  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
//  NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
//  DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
//  OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
//  USE OR OTHER DEALINGS IN THE SOFTWARE.
Object.defineProperty(exports, "__esModule", { value: true });
var Action_1 = require("./Action");
var EmitAction_1 = require("./EmitAction");
exports.EmitAction = EmitAction_1.default;
var EventTimeoutAction_1 = require("./EventTimeoutAction");
exports.EventTimeoutAction = EventTimeoutAction_1.default;
var GenericTimeoutAction_1 = require("./GenericTimeoutAction");
exports.GenericTimeoutAction = GenericTimeoutAction_1.default;
var NextEventAction_1 = require("./NextEventAction");
exports.NextEventAction = NextEventAction_1.default;
var PostponeAction_1 = require("./PostponeAction");
exports.PostponeAction = PostponeAction_1.default;
var ReplyAction_1 = require("./ReplyAction");
exports.ReplyAction = ReplyAction_1.default;
var StateTimeoutAction_1 = require("./StateTimeoutAction");
exports.StateTimeoutAction = StateTimeoutAction_1.default;
var TimeoutAction_1 = require("./TimeoutAction");
exports.TimeoutAction = TimeoutAction_1.default;
exports.default = Action_1.default;
/**
 * @hidden
 */
function isGenericTimeoutAction(a) {
    return a.type === 'genericTimeout';
}
exports.isGenericTimeoutAction = isGenericTimeoutAction;
/**
 * @hidden
 */
function isEventTimeoutAction(a) {
    return a.type === 'eventTimeout';
}
exports.isEventTimeoutAction = isEventTimeoutAction;
/**
 * @hidden
 */
function isStateTimeoutAction(a) {
    return a.type === 'stateTimeout';
}
exports.isStateTimeoutAction = isStateTimeoutAction;
/**
 * @hidden
 */
function isReplyAction(a) {
    return a.type === 'reply';
}
exports.isReplyAction = isReplyAction;
/**
 * @hidden
 */
function isNextEventAction(a) {
    return a.type === 'nextEvent';
}
exports.isNextEventAction = isNextEventAction;
/**
 * @hidden
 */
function isPostponeAction(a) {
    return a.type === 'postpone';
}
exports.isPostponeAction = isPostponeAction;
/**
 * @hidden
 * @param a
 * @return {boolean}
 */
function isEmitAction(a) {
    return a.type === 'emit';
}
exports.isEmitAction = isEmitAction;
//# sourceMappingURL=index.js.map